module.exports = __webpack_public_path__ + "static/media/muna_kaki_talking_loop.2c507e82.gif";